// Action Types
export enum Types {
  TOKEN_VALIDATE = 'user/TOKEN_VALIDATE',
  TOKEN_VALIDATE_SUCCESS = 'user/TOKEN_VALIDATE_SUCCESS',
  TOKEN_VALIDATE_FAILURE = 'user/TOKEN_VALIDATE_FAILURE',

  LOAD_USER = 'user/LOAD_USER',
  LOAD_USER_SUCCESS = 'user/LOAD_USER_SUCCESS',
  LOAD_USER_FAILURE = 'user/LOAD_USER_FAILURE',

  UPDATE_USER_PREFERENCES = 'user/UPDATE_USER_PREFERENCES',

  SAVE_USER = 'user/SAVE_USER',
  SAVE_USER_SUCCESS = 'user/SAVE_USER_SUCCESS',
  SAVE_USER_FAILURE = 'user/SAVE_USER_FAILURE',

  SWAP_USER_VIEW_TYPE = 'user/SWAP_USER_VIEW_TYPE',

  USER_LOGOUT = 'user/USER_LOGOUT',

  RESET_USER_SESSION = 'user/RESET_USER_SESSION'
}

export enum ECustomerTypeView {
  EMITTER = 'soldTo',
  RECEIVER = 'shipTo',
  FABRICATION_RECEIVER = 'fabricationShipTo'
}

export interface IUser {
  id: string;
  name: string;
  email: string;
  facebookId: string;
  linkedinId: string;
  status: string;
  isManager: boolean;
  journeyViews?: string[];
  phones: IUserPhone[];
  preferences: IUserPreference[];
  roles: IUserRoles;
  sendOrdersToEmail: boolean;
  sendFinancialToEmail: boolean;
  searchCustomerType: ECustomerTypeView;
  expecialSteel: boolean;
  salesRep: boolean;
  modalsToSkip?: string[];
  restrictedUsersManagement?: boolean;
  terms: IUserTerms;
  userSurveys?: IUserSurveys;
  businessType?: string;

  coreTeam: boolean;
}

export interface IUserSurveys {
  userNps: {
    improvementSurveyNps: string;
    npsRating: string;
    npsText: string;
    gerdauProModal: boolean;
    mhsRating: string;
  };
  newJorneySurveyShowcase: jorneySurvey;
  newJorneySurveyHistory: jorneySurvey;
  newJorneySurveyItems: jorneySurvey;
  newJorneySurveySheet: jorneySurvey;
}

export interface jorneySurvey {
  status: string;
  surveyRating: string;
  surveyText: string;
}

export interface IUserTerms {
  userAcceptNotification: boolean;
  improvementResearch: boolean;
  privacyTerms: boolean;
  improvementResearchNps?: EResearchNps;
  gerdauProModal: boolean;
}

export interface IUserState extends IUser {
  loading: boolean;
  userLoaded: boolean;
  error: boolean;
  loggingOut: boolean;

  savingUser: boolean;
  errorSavingUser: boolean;

  userPermissions: IUserPermissions;
  userRestrictions: IUserRestrictions;
  errorMessage?: string;
}

export interface IUserRestrictions {
  usersManagement: boolean;
}

export interface IUserPermissions {
  hasFinancialAccess: boolean;
  hasOrderViewAccess: boolean;
  hasOrderInputAccess: boolean;
  hasAccessManagementAccess: boolean;
  hasFabricationAccess: boolean;
  hasLoyaltyAccess: boolean;
}

export interface IUserPhone {
  number: string;
  isWhatsappNumber?: boolean;
}

export enum EUserPreferenceType {
  ORDERS = 'orders',
  ORDER_ENTRY = 'order-entry',
  HELPERS = 'helpers',
  LONG_STEEL = 'long-steel',
  FINANCIALS = 'financials',
  ORDER_VIEW = 'order-view',
  ORDER_ONBOARDING = 'order-onboarding'
}
export interface IUserPreference {
  name: EUserPreferenceType;
  ordersItens?: IUserOrderItemPreference;
  preferenceItems?: string[];
  ordersItensFinancials?: IUserInvoiceItemPreference;
  toggles?: IOrderViewToggles[];
}

export interface IOrderEntryPreference extends IUserPreference {
  spreadsheetColumns: ISpreadsheetColumn[];
  spreadsheetLine: number;
  codeType: ECodeType;
}

export interface IOrderViewPreference extends IUserPreference {
  toggles: IOrderViewToggles[];
}

export interface IOrderViewToggles {
  value: string;
  checked: boolean;
}

// Sheet
export enum ECodeType {
  SKU = 'SKU',
  CLIENT_SKU = 'CLIENT_SKU'
}

export enum ESpreadsheetField {
  SKU = 'SKU',
  CLIENT_SKU = 'CLIENT_SKU',
  QUANTITY = 'SKU_QUANTITY',
  UNITY = 'SKU_MEASURE_UNITY',
  DESIRED_DATE = 'DESIRED_DATE',
  CUSTOMER_PURCHASE_ITEM = 'CUSTOMER_PURCHASE_ITEM'
}
export interface ISpreadsheetColumn {
  key: number;
  field: ESpreadsheetField;
  label: string;
  position: string;
}
//
export interface IUserOrderItemPreference {
  idOrder: string;
  idProduct: string;
}

export interface IUserRoles {
  adminCustomers: string[];
  financialCustomers: string[];
  ordersInputCustomers: string[];
  ordersViewCustomers: string[];
  ordersViewPriceCustomers: string[];
  loyaltyCustomers?: string[];

  fabricationViewCustomers: string[] | null;
  // ordersViewShipToCustomers: string[];
}

export enum ECustomerUserPermissionType {
  ADMIN = 'adminCustomers',
  FINANCIAL = 'financialCustomers',
  VIEW_ORDERS = 'ordersViewCustomers',
  VIEW_PRICES = 'ordersViewPriceCustomers',
  INPUT_ORDERS = 'ordersInputCustomers',
  VIEW_FABRICATION = 'fabricationViewCustomers',
  LOYALTY = 'loyaltyCustomers'
}

export enum EResearchNps {
  PENDING = 'pending',
  ANSWERED = 'answered',
  DECLINED = 'declined'
}

export interface IUserInvoiceItemPreference {
  idOrder: string;
}

export enum EInvoiceColumn {
  ORDER_NUMBER = '0',
  SALES_ORDERS = '1'
}

export interface ISaveUser {
  user: IUser;
  userPreference?: IUserPreference;
  sendOrdersToEmail?: boolean;
  sendFinancialToEmail?: boolean;
  userAcceptNotification?: boolean;
  improvementResearch?: boolean;
  privacyTerms?: boolean;
  userName?: string;
  improvementResearchNps?: EResearchNps;
  jorneySurveyShowcaseStatus?: EResearchNps;
  jorneySurveyHistoryStatus?: EResearchNps;
  jorneySurveyItemsStatus?: EResearchNps;
  jorneySurveySheetStatus?: EResearchNps;
  gerdauProModal?: boolean;
}

export const orderViewPreferenceDefault: IOrderViewPreference = {
  name: EUserPreferenceType.ORDER_VIEW,
  toggles: [
    { value: 'salesOrder', checked: true },
    { value: 'sku', checked: true },
    { value: 'customerSKU', checked: false },
    { value: 'materialDescription', checked: false },
    { value: 'creationDateTable', checked: false },
    { value: 'requestedDateTable', checked: true },
    { value: 'futureDeliveriesTable', checked: false },
    { value: 'emitter', checked: true },
    { value: 'receiver', checked: false },
    { value: 'customerOrder', checked: true },
    { value: 'salesOrderItem', checked: false },
    { value: 'divisionDescription', checked: false },
    { value: 'totalQuantityRequested', checked: false },
    { value: 'totalQuantityConfirmed', checked: false },
    { value: 'totalQuantityPending', checked: false },
    { value: 'totalQuantityDelivery', checked: false },
    { value: 'totalQuantityShipment', checked: false },
    { value: 'totalQuantityBilled', checked: false },
    { value: 'meltShop', checked: false },
    { value: 'rollingMill', checked: false },
    { value: 'rollingFinish', checked: false },
    { value: 'finish', checked: false },
    { value: 'stockMill', checked: false },
    { value: 'transit', checked: false },
    { value: 'stockWarehouse', checked: false },
    { value: 'futureDeliveriesDate', checked: false },
    { value: 'futureDeliveriesQuantity', checked: false },
    { value: 'futureDeliveriesUnit', checked: false },

    // Identificação / Geral
    { value: 'codeAndDescription', checked: true }, // Coluna com código e descrição
    { value: 'orderStatus', checked: true }, // Status do pedido

    // Produção
    { value: 'productionStatus', checked: true }, // Status de produção

    // Pagamento (Comum para ambos os status)
    { value: 'paymentCondition', checked: false },
    { value: 'unitPriceTax', checked: false },
    { value: 'unitPriceNoTax', checked: false },
    { value: 'totalPriceTax', checked: false },
    { value: 'totalPriceNoTax', checked: false },

    // Outras Informações (Aberto)
    { value: 'nextEstimatedDate', checked: true }, // Próxima data estimada
    { value: 'deliveryStatus', checked: false }, // Status de entrega

    // Específicos de FATURADO
    { value: 'danfeNumber', checked: true }, // Nº Nota Fiscal
    { value: 'invoiceBillNumber', checked: false }, // Nº Fatura
    { value: 'shippingNoteNumber', checked: false }, // Nº Nota Remessa
    { value: 'billedQuantity', checked: true }, // Qtd Faturada
    { value: 'dueDate', checked: true }, // Data Vencimento
    { value: 'invoiceTotalTax', checked: false }, // Total Fatura c/ Impostos
    { value: 'invoiceTotalNoTax', checked: false }, // Total Fatura s/ Impostos
    { value: 'billingDate', checked: true }, // Data Faturamento
    { value: 'creationDate', checked: false }, // Data Criação
    { value: 'accessKey', checked: false }, // Chave de Acesso
    { value: 'heatNumber', checked: false }, // Corrida

    { value: 'newLongSteelOrdersView', checked: true } // Preferencias de visualização do usuário
  ]
};
